import { getMainSubdomain, getRootDomain } from '@constants/subdomains'

export type HostRoute =
  | {
      kind: 'main'
      hostname: string
      subdomain: string
    }
  | {
      kind: 'game'
      hostname: string
      subdomain: string
    }

function normalizeHostname(hostname: string) {
  return hostname.split(':', 1)[0].toLowerCase()
}

function getMainHostname() {
  const mainSubdomain = getMainSubdomain()
  const rootDomain = getRootDomain()

  return mainSubdomain ? `${mainSubdomain}.${rootDomain}` : rootDomain
}

export function getMainLoginUrl(hostname: string, protocol: string) {
  const normalizedHostname = normalizeHostname(hostname)

  if (
    normalizedHostname === 'localhost' ||
    normalizedHostname === '127.0.0.1'
  ) {
    return '/login/'
  }

  const normalizedProtocol = protocol.endsWith(':') ? protocol : `${protocol}:`

  return `${normalizedProtocol}//${getMainHostname()}/login/`
}

export function getMainHomeUrl(hostname: string, protocol: string) {
  const normalizedHostname = normalizeHostname(hostname)

  if (
    normalizedHostname === 'localhost' ||
    normalizedHostname === '127.0.0.1'
  ) {
    return '/'
  }

  const normalizedProtocol = protocol.endsWith(':') ? protocol : `${protocol}:`

  return `${normalizedProtocol}//${getMainHostname()}/`
}

export function getCurrentMainHomeUrl() {
  return getMainHomeUrl(
    globalThis.location.hostname,
    globalThis.location.protocol,
  )
}

export function redirectToMainLogin() {
  globalThis.location.assign(
    getMainLoginUrl(globalThis.location.hostname, globalThis.location.protocol),
  )
}

export function getHostRoute(hostname: string): HostRoute {
  const normalizedHostname = normalizeHostname(hostname)
  const rootDomain = getRootDomain()
  const mainSubdomain = getMainSubdomain()

  if (
    normalizedHostname === 'localhost' ||
    normalizedHostname === '127.0.0.1'
  ) {
    return {
      kind: 'main',
      hostname: normalizedHostname,
      subdomain: mainSubdomain,
    }
  }

  if (normalizedHostname === rootDomain) {
    return {
      kind: 'main',
      hostname: normalizedHostname,
      subdomain: mainSubdomain,
    }
  }

  const suffix = `.${rootDomain}`
  const subdomain = normalizedHostname.endsWith(suffix)
    ? normalizedHostname.slice(0, -suffix.length)
    : normalizedHostname.split('.', 1)[0]

  return {
    kind: mainSubdomain && subdomain === mainSubdomain ? 'main' : 'game',
    hostname: normalizedHostname,
    subdomain,
  }
}

export function getCurrentHostRoute() {
  return getHostRoute(globalThis.location.hostname)
}
